import { render } from "./CreateInvites.vue?vue&type=template&id=186afe48&scoped=true"
import script from "./CreateInvites.vue?vue&type=script&lang=js"
export * from "./CreateInvites.vue?vue&type=script&lang=js"

import "./CreateInvites.vue?vue&type=style&index=0&id=186afe48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186afe48"]])

export default __exports__